import { useParams } from "react-router-dom"

/**
 * Custom hook that checks the URL for /chat/sessionId pattern
 * @returns sessionId string if found, null otherwise
 */
export function useSessionId(): string | null {
  const params = useParams()

  return params.sessionId ?? null
}
